// extracted by mini-css-extract-plugin
export default {"someClass":"Atom_someClass__9uXMf"};